import './index.css';
import { jsx } from 'react/jsx-runtime';
import { Card } from '@hh.ru/magritte-ui-card';
import { Text } from '@hh.ru/magritte-ui-typography';

const MobileDelimiter = ({ children }) => {
    return (jsx(Card, { padding: 16, paddingTop: 8, paddingBottom: 0, stretched: true, children: jsx(Text, { typography: "label-3-regular", style: "secondary", children: children }) }));
};

export { MobileDelimiter };
//# sourceMappingURL=MobileDelimiter.js.map
